module.exports = __webpack_public_path__ + "static/media/asc-parking-selected.6796ae3b.svg";